import * as api from './api';
import types from './types';

import {promiseAction} from '~/misc/dispatch';
import {tipsChange} from '~/modules/tips/actions';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {getUserData} from '~/modules/user/actions'

export const verifyEmailAction = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.VERIFY_EMAIL,
  api.verifyEmail(getState)
  .then(() => {
    dispatch(tipsChange(
      {type: 'success', source: 'verify-email'},
      `We have sent a confirmation link to ${getState().user.email}.`));
  })
  .catch(error => {
    dispatch(tipsChange(
      {type: 'failed', source: 'verify-email'},
      'Something went wrong please try again. If the problem persists, please contact us.'));
    throw error;
  })
);

export const sendPhone = (phoneNumber) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.VERIFY_SEND_PHONE_CODE,
  api.sendPhoneVerifyCode(getState, phoneNumber)
);


export const verifyPhoneAction = (phoneNumber, code) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.VERIFY_PHONE,
  api.verifyPhone(getState, phoneNumber, code)
  .then((res)=>{
    dispatch((dispatch, getState) => {
      const token = getState().user.token;
      getUserData(dispatch, getState, token)
    })
    return res;
  })
);

export const verifyPhoneActionFromEmail = (phoneNumber, code) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.VERIFY_PHONE,
  api.verifyPhoneFromEmail(getState, phoneNumber, code)
  .then((res)=>{
    dispatch((dispatch, getState) => {
      const token = getState().user.token;
      getUserData(dispatch, getState, token)
    })
    return res;
  })
);


// WEBPACK FOOTER //
// ./src/modules/verify/actions.js